var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-spinner',{class:'spinner ' + _vm.styling,attrs:{"label":_vm.lLabel,"variant":_vm.lVariant,"small":_vm.lSmall}})}
var staticRenderFns = []

export { render, staticRenderFns }